import React, { forwardRef } from 'react';
import PortalElement from './PortalElement';
import { LockIcon } from './icons';

/**
 * The venue block, in one of the eleven shared styles, for people who may see the venue:
 * `venue` = { name, address, city }; `date` = the Portal's window bits for DATE.
 *
 * For a viewer the host hasn't let in yet the server sends no name at all, only that there is
 * a place (`venue.locked`) and the city: the card draws the locked placeholder at the venue's
 * own position and rotation, never scaled, so it stays readable (venue-lock handoff §4).
 */
export function LockedVenue({ city = '' }) {
  return (
    <div className="font-mono" data-testid="portal-venue-locked" style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(0,0,0,.72)', borderRadius: 999, padding: '6px 18px 6px 6px', color: '#fff' }}>
      <span aria-hidden style={{ width: 34, height: 34, flexShrink: 0, borderRadius: '50%', background: 'rgba(255,255,255,.14)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><LockIcon size={14} /></span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.12em' }}>PLACE SHOWS ONCE YOU’RE IN</div>
        {city && <div style={{ marginTop: 2, fontSize: 10, color: 'rgba(255,255,255,.7)', textTransform: 'uppercase' }}>{city}</div>}
      </div>
    </div>
  );
}

const PortalVenue = forwardRef(function PortalVenue({ venue, layout, date = null, ...rest }, ref) {
  if (venue?.locked) {
    const rot = layout.rot?.venue || 0;
    return (
      <div
        ref={ref}
        data-el="venue"
        style={{ position: 'absolute', left: `${layout.venue.x}%`, top: `${layout.venue.y}%`, maxWidth: '86%', padding: 6, boxSizing: 'border-box', transform: rot ? `rotate(${rot}deg)` : undefined, transformOrigin: '50% 50%', zIndex: 4, pointerEvents: 'none' }}
      >
        <LockedVenue city={venue.city} />
      </div>
    );
  }
  if (!venue?.name) return null;
  const data = { title: venue.name, meta: venue.address || '', city: venue.city || '', ...(date || {}) };
  return (
    <PortalElement
      ref={ref}
      kind="venue"
      style={layout.venueStyle}
      data={data}
      pos={layout.venue}
      rot={layout.rot?.venue}
      scl={layout.scl?.venue}
      {...rest}
    />
  );
});

export default PortalVenue;
